import { Injectable, signal } from "@angular/core";
import { AppSettingsNavigationCategoryExtension } from "@geolib/geoappbase-client";

@Injectable({ providedIn: "root" })
export default class GeobusUserOrganisationExtension extends AppSettingsNavigationCategoryExtension {

    public isEnabled(): boolean {
        return true;
    }

    public name = signal("user_and_organisation").asReadonly();

    public label = signal("SIDE_MENU.USER_ORGANISATION.CATEGORY").asReadonly();

}
